import { render, staticRenderFns } from "./addBalance.vue?vue&type=template&id=2073c881&scoped=true&"
import script from "./addBalance.vue?vue&type=script&lang=js&"
export * from "./addBalance.vue?vue&type=script&lang=js&"
import style0 from "./addBalance.vue?vue&type=style&index=0&id=2073c881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073c881",
  null
  
)

export default component.exports